import styled from "@emotion/styled";
import Drawer from "@mui/material/Drawer";
import { fontAngkor } from "@product/scmp-sdk";

import { PostiesStudentForm } from "scmp-app/components/posties/student-form";
import { ZIndexLayer } from "scmp-app/lib/styles";

import SvgClose from "./icon-close.svg";
import SvgBottom from "./svg-bottom.svg";
import SvgPeter from "./svg-peter.svg";

export const StyledDrawer = styled(Drawer)`
  z-index: ${ZIndexLayer.Drawer};

  inline-size: 100%;
  max-inline-size: 485px;
`;

export const Container = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 100%;
  max-inline-size: 485px;

  background-color: #dcf1fa;
`;

export const CloseContainer = styled.div`
  position: fixed;
  z-index: 1;

  display: flex;
  justify-content: flex-end;

  inline-size: 100%;
  max-inline-size: 485px;
  padding-block-start: 24px;
  padding-inline: 24px;

  background-color: #dcf1fa;
`;

export const CloseButton = styled(SvgClose)`
  cursor: pointer;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  block-size: calc(100%);
  padding-block-start: 39px;

  overflow-y: auto;
`;

export const TitleContainer = styled.div`
  position: relative;

  display: flex;
  align-items: flex-end;

  margin-block-end: 24px;
  margin-inline: 24px;
`;

export const Title = styled.div`
  flex: 1;

  margin-block-end: 10.45px;
  margin-inline-end: -20px;

  color: #1b4191;
  font-size: 28px;
  font-family: ${fontAngkor};
  line-height: 34px;
  letter-spacing: -0.04em;
`;

export const Peter = styled(SvgPeter)``;

export const StyledPostiesStudentForm = styled(PostiesStudentForm)``;

export const StyledSvgBottom = styled(SvgBottom)`
  inline-size: 100%;
  block-size: auto;
  margin-block-end: -2px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  block-size: 100%;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  block-size: 100%;
`;
